import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from "react-bootstrap";

import { isLoggedIn } from '../../../../data/user.model';
import { isEcommerceEnabled } from '../../../../selectors/generic';
import { redirectToLogin } from '../../../../actions/auth';
import Link from '../../../atoms/text/Link';
import { useI18N } from "../../../my-puratos/hoc/withI18N";
import { ProductContext } from "../../../pages/ProductStencil";
import { AddToCartButton } from "../overview/Actions/AddToCart/AddToCartButton";

export const ProductCardFooter = ({ product, componentType }) => {
    const dispatch = useDispatch();
    const translate = useI18N();
    const { stencil } = useContext(ProductContext);
    const packaging = product.Packagings && product.Packagings[0];
    const minQuantity = packaging && packaging.MinimumOrderableQuantity > 0 ? packaging.MinimumOrderableQuantity : 1;
    const [quantity, setQuantity] = useState(minQuantity);
    const { maximumAddToCartQuantity } = stencil;

    const currentQuantity = useSelector((state: any) =>
        state?.myPuratos_cart?.data?.basketItems?.find(
            item => item.materialNumber.toString() === packaging.MaterialNumber.toString()
        )?.quantity || 0
    );

    const handleIncrement = () => {
        if (quantity < maximumAddToCartQuantity) {
            setQuantity(quantity + 1);
        }
    };

    const handleDecrement = () => {
        if (quantity > minQuantity) {
            setQuantity(quantity - 1);
        }
    };

    const handleChange = (e) => {
        setQuantity(e.target.value);
    };

    const handleBlur = () => {
        const minimum = minQuantity > 0 ? minQuantity : 1;
        setQuantity(prev => Math.max(minimum, Math.min(maximumAddToCartQuantity, Number(prev))));
    };

    const loggedOutFooter = (
        <>
            <Button color="secondary" className="btn-secondary product-card__sign-in" onClick={() => dispatch(redirectToLogin())}>
                {translate("Sign in to view prices")}
            </Button>
            <Link
                color="p-color-black"
                href={stencil.signUpUrl}
                className="product-card__sign-up"
            >
                {translate("Create an account")}
            </Link>
        </>
    );

    const addedToCardTranslatedText = currentQuantity > 0 ?
    (currentQuantity > 1 ?
        translate('You currently have {0} items in your cart', [`<strong>${currentQuantity}</strong>`]) :
        translate('You currently have {0} item in your cart', [`<strong>${currentQuantity}</strong>`])
    ) : false;

    const loggedInFooter = (
        <>
            {addedToCardTranslatedText &&
              <p className={"add-to-cart__quantity-info"} dangerouslySetInnerHTML={{__html: addedToCardTranslatedText}}></p>
            }
            {(packaging && packaging.HasPrice && !packaging.IsObsolete) && (
                <div className="add-to-cart__controls">
                    <button
                        className={"add-to-cart__controls--decrement"}
                        onClick={handleDecrement}
                        disabled={quantity <= minQuantity}
                        aria-label={translate("Decrement quantity")}
                    ></button>
                    <input
                        type="number"
                        value={quantity}
                        aria-label={translate("Quantity input")}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        min={minQuantity}
                        max={maximumAddToCartQuantity}
                    />
                    <button
                        className={"add-to-cart__controls--increment"}
                        onClick={handleIncrement}
                        disabled={quantity >= maximumAddToCartQuantity}
                        aria-label={translate("Increment quantity")}
                    ></button>
                </div>
            )}
            <AddToCartButton
                product={product}
                componentType={componentType}
                quantity={quantity}
                showBasketOverlay={false}
            />
        </>
    );

    const renderedProductCardFooter = isEcommerceEnabled() ? (
        isLoggedIn()
            ? loggedInFooter
            : loggedOutFooter
        ) : null;

    return <>{renderedProductCardFooter}</>;
};
